import { Card, ListGroup } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { CircularProgress } from "@mui/material";
import LanOutlinedIcon from "@mui/icons-material/LanOutlined";
import { getWhereUsed } from "utils/utils";
import BeSafeButton from "components/commons/BeSafeButton";
import { Delete, Edit } from "@mui/icons-material";

const NetworkSubList = ({
  previewLoading,
  networks,
  selectedNetwork,
  deleteNetworkObject,
  showEditNetworkModal,
}) => {
  const whereUsed = getWhereUsed(selectedNetwork);

  return (
    <>
      {previewLoading ? (
        <div className="d-flex card justify-content-center align-items-center w-60 h-100 mr3">
          <CircularProgress />
        </div>
      ) : networks.length <= 0 ? (
        <span className="card w-60 h-100 mr-3 p-3 text-center pt-5">
          <FormattedMessage id="GENERAL.NO_DATA" />
        </span>
      ) : (
        <Card className="w-60 h-100 mr-3">
          <Card.Header>
            <Card.Title className="d-flex justify-content-between py-0 my-0 text-cus-heading">
              <span className="my-auto">
                <LanOutlinedIcon className="mr-2" />
                {selectedNetwork.name}
              </span>
              {selectedNetwork.editable && (
                <div>
                  <BeSafeButton
                    variant="transparent"
                    className="px-1 py-0"
                    onClick={showEditNetworkModal}
                    icon={<Edit className="icon-table-md" />}
                    tooltip="GENERAL.EDIT_SMALL"
                  />
                  <BeSafeButton
                    variant="transparent"
                    className="px-1 py-0"
                    onClick={deleteNetworkObject}
                    icon={<Delete className="icon-table-md" />}
                    tooltip="GENERAL.DELETE_SMALL"
                  />
                </div>
              )}
            </Card.Title>
          </Card.Header>
          <Card.Body className="overflow-auto">
            <div className="d-flex py-2">
              <span className="font-weight-bold">
                <FormattedMessage id="GENERAL.DESCRIPTION" />
              </span>
              <span>{`: ${selectedNetwork?.description || ""}`}</span>
            </div>
            <div className="d-flex py-2">
              <span className="font-weight-bold">
                <FormattedMessage id="NETWORK_OBJECTS.TYPE" />
              </span>
              <span>{`: ${
                selectedNetwork?.data?.network_type?.toUpperCase()
              }`}</span>
            </div>
            <div className="d-flex py-2">
              <span className="font-weight-bold">
                <FormattedMessage id="NETWORK_OBJECTS.IPV4" />
              </span>
              <span>{`: ${selectedNetwork?.target}`}</span>
            </div>
            <div className="d-flex py-2">
              <span className="font-weight-bold">
                <FormattedMessage id="NETWORK_OBJECTS.IPV6" />
              </span>
              <span>{`: ${selectedNetwork?.target_secondary}`}</span>
            </div>
            {selectedNetwork?.besafe_groups?.length > 0 &&
            <>
              <div className="d-flex py-2">
                <span className="font-weight-bold">
                  <FormattedMessage id="NETWORK_OBJECTS.GROUPS" />
                </span>
              </div>
              <ListGroup>
                {selectedNetwork?.besafe_groups?.map((group, index) => (
                  <ListGroup.Item
                    key={group.id}
                    className="d-flex justify-content-between py-0"
                  >
                    <span className="w-75 py-2">{group.name}</span>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </>}
          </Card.Body>
          <Card.Footer className="obj-where-used">
            <p className="font-weight-bold my-0">
              <FormattedMessage id="GENERAL.WHERE_USED" />:
            </p>
            <span>
              {whereUsed?.length <= 0 ? (
                <FormattedMessage id="GENERAL.NOT_IN_USE" />
              ) : (
                whereUsed?.map((r) => r).join(", ")
              )}
            </span>
          </Card.Footer>
        </Card>
      )}
    </>
  );
};

export default NetworkSubList;
